// Texte für die Befehlspalette (Strg/⌘+K). Die Gruppenüberschriften der Entitäten stehen bewusst
// nicht hier — sie nutzen die `nav.*`-Labels, damit ein Bereich in der Navigation und in der
// Palette gleich heißt.
export default {
  label: "Suche",
  placeholder: "Suchen oder springen zu…",
  groups: {
    recent: "Zuletzt besucht",
    create: "Anlegen",
    navigate: "Gehe zu",
  },
  empty: {
    no_results: "Nichts gefunden.",
    keep_typing: "Weitertippen, um zu suchen…",
  },
  hints: {
    move: "Navigieren",
    open: "Öffnen",
    close: "Schließen",
    back: "Zurück",
  },
  // Ein Tab wie „Bautagesberichte“ braucht eine Entität, auf der er geöffnet wird. Diese Texte
  // benennen den zweiten Schritt — Singular, weil genau eine gewählt wird (die `nav.*`-Labels sind
  // Plural und lesen sich hier falsch).
  pick: {
    PROJECT: "Projekt wählen",
    CUSTOMER: "Kunde wählen",
    USER: "Mitarbeiter wählen",
    MATERIAL: "Material wählen",
    MACHINE: "Maschine wählen",
    SUPPLIER: "Lieferant wählen",
    ADDITIONAL_EFFORT: "Zusatzaufwand wählen",
    PACKET: "Paket wählen",
  },
}
